export const DebtGroupTypes = {
  SHOW_DEBT_GROUP: 'SHOW_DEBT_GROUP',
  ADD_DEBT_GROUP: 'ADD_DEBT_GROUP',
  UPDATE_DEBT_GROUP: 'UPDATE_DEBT_GROUP',
  DELETE_DEBT_GROUP: 'DELETE_DEBT_GROUP',
}
